import React from 'react';
import PropTypes from 'prop-types';
import { Waypoint } from 'react-waypoint';
import { isCategoryExpired } from '../../../utilities/SelectionDeadlineUtility';

const CategoryItemLocked = ({ category, isLastItem }) => (
  <div className="category-item-locked">
    <Waypoint topOffset={200} />
    <div className="category-title-button">
      <div className="container-name-plus">
        <div className="name">
          {category.name}
          {isCategoryExpired(category) && <span className="deadline-notice">(Fecha límite alcanzada)</span>}
        </div>
      </div>
      {category.incompatibleWith !== null ? (
        <div className="incompatible-with">
          ( Incompatible con: {category.incompatibleWith} )
        </div>
        ) : (
          <div className="available-if">
            ( Requisitos: {category.availableIf} )
          </div>
        )}

    </div>

    <div className="divider" />
    {isLastItem
          ? (<Waypoint topOffset={30} />)
                : (<Waypoint topOffset={200} />)}


  </div>
);

CategoryItemLocked.propTypes = {
    category: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        cameras: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.string,
            roomId: PropTypes.string,
            isPriority: PropTypes.bool,
        })),
        selected_feature: PropTypes.string,
        availableIf: PropTypes.string,
        incompatibleWith: PropTypes.string,
        type: PropTypes.string,
    }).isRequired,
    isLastItem: PropTypes.bool.isRequired,
};

export default CategoryItemLocked;
